import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            class="ns-remove-selected-filter-btn"
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-selected-filters-container">
                {filters.map(filter => (
                    <div class="ns-selected-filter">
                        <span class="ns-selected-filter-text">
                            {filter.name} - {filter.value}
                        </span>
                        <FilterRemoveButton filter={filter} />
                    </div>
                ))}
            </div>
        )
    )
}
